// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Wiki layout (left sidebar + main content area).
 */

.wiki-layout {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.wiki-sidebar {
  flex: 0 0 240px;
  background-color: var(--gh-canvas-default);
  border: 1px solid var(--gh-border-default);
  border-radius: var(--gh-radius);
  overflow: hidden;
}

.wiki-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--gh-border-default);
  background-color: var(--gh-canvas-inset);
}

.wiki-sidebar-message {
  padding: 12px 16px;
  font-size: 13px;
}

.wiki-sidebar-list {
  list-style: none;
  margin: 0;
  padding: 8px 0;
}

.wiki-sidebar-item {
  display: flex;
  align-items: stretch;
}

.wiki-sidebar-drag-handle {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 2px 0 8px;
  background: none;
  border: none;
  color: var(--gh-fg-muted);
  font-size: 12px;
  cursor: grab;
  touch-action: none;
}

.wiki-sidebar-drag-handle:active {
  cursor: grabbing;
}

.wiki-sidebar-toggle {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 0 4px 0 2px;
  background: none;
  border: none;
  color: var(--gh-fg-default);
  font-size: 11px;
  cursor: pointer;
}

.wiki-sidebar-item .wiki-sidebar-link {
  flex: 1 1 auto;
  padding-left: 4px;
}

.wiki-sidebar-sublist {
  list-style: none;
  margin: 0;
  padding: 0 0 4px;
}

.wiki-sidebar-sublist .wiki-sidebar-item {
  padding-left: 28px;
}

.wiki-sidebar-sublist .wiki-sidebar-link {
  font-size: 13px;
}

.wiki-sidebar-link {
  display: block;
  margin-right: 8px;
  padding: 6px 16px;
  color: var(--gh-fg-default);
  font-size: 14px;
  border-radius: var(--gh-radius);
}

.wiki-sidebar-link:hover {
  background-color: var(--gh-canvas-subtle);
  text-decoration: none;
}

.wiki-sidebar-link.active {
  background-color: var(--gh-canvas-inset);
  color: var(--gh-accent-fg);
  font-weight: 600;
}

.wiki-main {
  flex: 1 1 auto;
  min-width: 0;
}

.wiki-sidebar-add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: var(--gh-radius);
  background-color: transparent;
  color: var(--gh-fg-muted);
  font-size: 12px;
  line-height: 1;
}

.wiki-sidebar-add-btn:hover {
  background-color: var(--gh-canvas-inset);
  color: var(--gh-fg-default);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,qBAAqB;AACvB","sourcesContent":["/*\n * Wiki layout (left sidebar + main content area).\n */\n\n.wiki-layout {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n}\n\n.wiki-sidebar {\n  flex: 0 0 240px;\n  background-color: var(--gh-canvas-default);\n  border: 1px solid var(--gh-border-default);\n  border-radius: var(--gh-radius);\n  overflow: hidden;\n}\n\n.wiki-sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--gh-border-default);\n  background-color: var(--gh-canvas-inset);\n}\n\n.wiki-sidebar-message {\n  padding: 12px 16px;\n  font-size: 13px;\n}\n\n.wiki-sidebar-list {\n  list-style: none;\n  margin: 0;\n  padding: 8px 0;\n}\n\n.wiki-sidebar-item {\n  display: flex;\n  align-items: stretch;\n}\n\n.wiki-sidebar-drag-handle {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  padding: 0 2px 0 8px;\n  background: none;\n  border: none;\n  color: var(--gh-fg-muted);\n  font-size: 12px;\n  cursor: grab;\n  touch-action: none;\n}\n\n.wiki-sidebar-drag-handle:active {\n  cursor: grabbing;\n}\n\n.wiki-sidebar-toggle {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  padding: 0 4px 0 2px;\n  background: none;\n  border: none;\n  color: var(--gh-fg-default);\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.wiki-sidebar-item .wiki-sidebar-link {\n  flex: 1 1 auto;\n  padding-left: 4px;\n}\n\n.wiki-sidebar-sublist {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 4px;\n}\n\n.wiki-sidebar-sublist .wiki-sidebar-item {\n  padding-left: 28px;\n}\n\n.wiki-sidebar-sublist .wiki-sidebar-link {\n  font-size: 13px;\n}\n\n.wiki-sidebar-link {\n  display: block;\n  margin-right: 8px;\n  padding: 6px 16px;\n  color: var(--gh-fg-default);\n  font-size: 14px;\n  border-radius: var(--gh-radius);\n}\n\n.wiki-sidebar-link:hover {\n  background-color: var(--gh-canvas-subtle);\n  text-decoration: none;\n}\n\n.wiki-sidebar-link.active {\n  background-color: var(--gh-canvas-inset);\n  color: var(--gh-accent-fg);\n  font-weight: 600;\n}\n\n.wiki-main {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.wiki-sidebar-add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: var(--gh-radius);\n  background-color: transparent;\n  color: var(--gh-fg-muted);\n  font-size: 12px;\n  line-height: 1;\n}\n\n.wiki-sidebar-add-btn:hover {\n  background-color: var(--gh-canvas-inset);\n  color: var(--gh-fg-default);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
